import SvgIcon from "@mui/material/SvgIcon";

export const ReceiptIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2z
         M8 6h8
         M8 10h8
         M8 14h4"
      fill="none"
      stroke="#0E60E2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);